import React from 'react';
import { Button, ProgressBar } from 'react-bootstrap';

const OtaProgressPanel = ({ otaState, otaInFlight, onClear }) => {
  if (otaState.status === 'idle') return null;

  const statusClass = otaState.status === 'complete'
    ? 'ota-status-panel--success'
    : otaState.status === 'error'
      ? 'ota-status-panel--error'
      : 'ota-status-panel--progress';

  return (
    <div className={`ota-status-panel ${statusClass}`}>
      <div className="d-flex justify-content-between align-items-center mb-2">
        <h6 className="mb-0">
          {otaState.status === 'complete' && '🚀 OTA Complete'}
          {otaState.status === 'error' && 'OTA Failed'}
          {otaState.status === 'aborted' && 'OTA Aborted'}
          {!['complete', 'error', 'aborted'].includes(otaState.status) && 'OTA In Progress'}
        </h6>
        {!otaInFlight && (
          <Button variant="outline-secondary" size="sm" onClick={onClear}>
            Clear
          </Button>
        )}
      </div>
      {otaInFlight && (
        <ProgressBar
          now={otaState.progress}
          label={`${otaState.progress}%`}
          animated
          striped
          className="mb-2"
        />
      )}
      <p className="mb-0 small text-app-muted">
        {otaState.status === 'complete' && 'Device received the firmware and should restart shortly.'}
        {otaState.status === 'error' && (otaState.error || 'The device reported an OTA error.')}
        {otaInFlight && 'Firmware is being sent in small MQTT chunks for reliability.'}
        {otaState.sessionId && (
          <>
            {' '}
            Session:
            {' '}
            <code>{otaState.sessionId.slice(0, 8)}</code>
          </>
        )}
      </p>
    </div>
  );
};

export default OtaProgressPanel;